const state = {
  token: localStorage.getItem('token') || '',
  userId: localStorage.getItem('userId') || '',
  username: localStorage.getItem('username') || '',
  tokenExpiresAt: localStorage.getItem('token_expires_at') || '',
  activeBot: 'null',
  hasHumanUnread: false,
  /** 侧边栏「群聊」小红点：由工作台定时调用 /group-chat/badge 更新 */
  hasGroupChatTodoDot: false,
}

export default state
